
import React from "react";
import DataTable from "react-data-table-component";
import { useState, useEffect } from "react";
import {
  IconButton,
  TextField,
  InputAdornment,
  Box,
  Button,
  Grid,
} from "@mui/material";
import "../../listings/Listing.css";
import { Search } from "@mui/icons-material";
import {
    getAclAuditRecords,
} from "../../common/constants/globalconstants";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { CustomExcelExport } from "../../common/CustomExcelExport";
import ErrorModal from "../../common/ErrorModal";
import axiosInstance from "../../common/AxiosInterceptor";
import { aclAuditColumns, aclAuditExcelColumns } from "./AclAuditColumns";

const customStyle = {
    table: {
      style: {
        border: "1px solid #DEDEDE",
        borderRadius: "5px",
        justifyContent: "center",
        marginBottom: "10px",
        marginTop: "10px",
      },
    },
    header: {
      style: {
        color: "#193062",
      },
    },
    headRow: {
      style: {
        border: "none",
        backgroundColor: "#CDD4DC",
        fontWeight: "bold",
        color: "#002d82",
        fontSize: "14px",
        whiteSpace: "unset",
      },
    },
    rows: {
      stripedStyle: {
        backgroundColor: "#F2F3F5",
        justifyContent: "center",
      },
    },
  };

function AclAudit() {
  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [loading, setloading] = useState(false); 
  const [aclAuditData, setAclAuditData]= useState([]);
  const [errormodalopen, seterrormodalOpen]= useState(false);
  const [isErr, setIsErr] =useState(false);
  const [searchField, setSearchField] =useState("");
  const [searching, setSearching] = useState(false);
  const [resetPagination, setRstPagination] = useState(false);
  const [tableKey, setTableKey] = useState(0);
  const [reqFields, setReqFields] = useState({
      updatedBy: "",
      userName: "",
      careFacility: ""
    });
  const [err, setErr] = useState("");

  useEffect(()=>{
    getAclAuditLogs();  
  },[]);


  
  const getAclAuditLogs = async() =>{
     try {
      setloading(true);
    const response = await axiosInstance.get(`${getAclAuditRecords}`);
        if(response.data.isSuccess){
           setAclAuditData(response.data.result);
           setTableData(response.data.result);
           setOriginalData(response.data.result);
           setTableKey(prevKey=> prevKey+1);
           seterrormodalOpen(false);
        }
        else if(!response.data.isSuccess){
          seterrormodalOpen(true);
        }
        setloading(false);
    } catch (error) {
      console.log(error.message);
      seterrormodalOpen(true);
      setloading(false);
    }
  }


  const handleChangeInput = (e) => {
    setRstPagination(!resetPagination);
    setSearching(true);
    setSearchField(e.target.value);
    let searchValue = false;
    let id = false;
    let userType = false;
    let userRoleId = false;
    let userName = false;
    let careFacility = false;
    let oldValue = false;
    let newValue = false;
    let updatedBy = false;
    let updatedDate = false;

    const newdata = tableData && tableData.filter((row) => {
      id = row.logId && row.logId.toString().includes(e.target.value.toString());
      userType = row.userType && row.userType.toLowerCase().toString().includes(e.target.value.toLowerCase().toString());
      userRoleId = row.userRoleId && row.userRoleId.toString().includes(e.target.value.toString());
      userName = row.userName && row.userName.toLowerCase().toString().includes(e.target.value.toLowerCase().toString());
      careFacility = row.careFacilityName && row.careFacilityName.toLowerCase().toString().includes(e.target.value.toLowerCase().toString());
      oldValue = row.oldRoleName && row.oldRoleName.toLowerCase().includes(e.target.value.toLowerCase());
      newValue = row.newRoleName && row.newRoleName.toLowerCase().includes(e.target.value.toLowerCase());
      updatedBy = row.updatedBy && row.updatedBy.toLowerCase().toString().toLowerCase().includes(e.target.value.toLowerCase().toString());
      updatedDate = row.updatedAt && row.updatedAt.toString().includes(e.target.value.toString());

      if (id) {
        searchValue = id;
      } 
      else if (userType) {
        searchValue = userType;
      } 
      else if (userRoleId) {
        searchValue = userRoleId;
      } 
      else if (userName) {
        searchValue = userName;
      } 
      else if (careFacility) {
        searchValue = careFacility;
      } 
      else if (oldValue) {
        searchValue = oldValue;
      }
      else if (newValue) {
        searchValue = newValue;
      } 
      else if (updatedBy) {
        searchValue = updatedBy;
      }     
      else {
        searchValue = updatedDate;
      }
      return searchValue;
    });
    setAclAuditData(newdata);
  };

  const handleChange=(e)=>{
    const value = e.target.value;
    setReqFields({...reqFields, 
      [e.target.name]: value
    });

    if(value || reqFields.updatedBy !== "" || reqFields.userName !== "" || reqFields.careFacility !== ""){
      setErr("");
    } 
  }

  const validate = () =>{
    let isError=false;
       if((reqFields.updatedBy ==="" || reqFields.updatedBy=== undefined || reqFields.updatedBy === null)
        && (reqFields.userName ==="" || reqFields.userName=== undefined || reqFields.userName === null)
        && (reqFields.careFacility ==="" || reqFields.careFacility=== undefined || reqFields.careFacility === null)
      ){
        setErr("Please provide any Search Criteria");
        setIsErr(true); 
        isError =true;
      }
      else{
        setErr("");
        setIsErr(false);
        isError =false;
      }
    return isError;
  }

  const handleReset = () =>{
      getAclAuditLogs();
      setReqFields({
        updatedBy:"",
        userName:"",
        careFacility:""
      })
      setErr({...err, searchFieldsErr:"", selectedRowsErr:""});
      setIsErr(false);
      setRstPagination(!resetPagination);
      setTableKey(prevKey =>prevKey+1);
      setSearchField("");
    }

    const handleSearch=() =>{
      setRstPagination(!resetPagination);
      setSearching(false);
      if(!validate()){
        const filteredList = originalData.filter(row =>{
          const match1 = (reqFields.updatedBy === "" || row.updatedBy.replace(" ","").toLowerCase().includes(reqFields.updatedBy.toLowerCase()));
          const match2 = (reqFields.userName === "" || row.userName.toLowerCase().includes(reqFields.userName.toLowerCase()));
          const match3 = (reqFields.careFacility === "" || row.careFacilityName.toLowerCase().includes(reqFields.careFacility.toLowerCase()));
          return match1 && match2 && match3 ;
      })
        setAclAuditData(filteredList);
      }
    }
      return (
        <div>
          {loading && (
            <>
              <Backdrop
                sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={true}
              >
                <CircularProgress sx={{ color: "white" }} />
                <span> &nbsp;&nbsp;&nbsp;&nbsp; Loading Data... </span>
              </Backdrop>
            </>
          )}
    
        <div>
          <Box
        sx={{
          position: "relative",
          alignContent:"center",
          justifyContent: "center",
          left: "1%",
          right: "2%",
          flexDirection: "column",
          width: "97%",
          marginTop: "10px",
          marginBottom: "10px",
          alignItems: "center",
          p: "0% 1%",
          backgroundColor: "#fcfcfc",
          //border: "2px solid #dfe3e8",
          borderRadius: "20px",
        }}
      >
          <h2 className="header">Access Control Audit Logs</h2>
         
            <div
                         style={{
                           display: "flex",
                           flexDirection: "row",
                         }}
                       >  
                     <Grid container>
                       <Box
                       sx={{height: "12px", width:"100%", color:"red", textAlign:"center"}}>
                         <p>{isErr && err}</p>
                       </Box>
                     <div style={{marginTop: "15px", width:"99%", marginRight:"18px"}}>              
                             <Box
                             sx={{
                               border:"1px solid #002d82",
                               position:"relative",
                               display:"inline-block",
                               barderRadius:"5px",
                               width: "100%",
                               padding:"8px",
                               //marginRight:"8px"
                             }}>
                                <Box
                                 display="flex"
                                 direction="row"
                                 alignItems="left"
                                 justifyContent="left"
                                 alignContent="left"
                                 columnGap="0.5rem"
                                 sx={{ width:"100%", height: "50px", m: "3px 0", marginTop:"5px" }} 
                             >
                          
                            <Grid xs={3}>
                             <Box
                               display="flex"
                               sx={{
                                 flexDirection: "row",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 alignContent: "center",
                                 height: "50px",
                                 fontSize: "15px"
                               }}
                             > 
                             
                               <p style={{width: "120px", color: "black",fontWeight: "600", marginLeft:"5px"}}>
                               User Name:</p>
                               <TextField
                               sx={{"& .MuiInputBase-input": {padding: "8.5px 14px"},"& .MuiFormControl-root":{alignContent:"center"}}}
                               placeholder="User Name"
                               type="text"
                               variant="outlined"
                               margin="normal"
                               name="userName"
                               value={reqFields.userName}
                               onChange={handleChange}
                               />
                             
                            </Box>
                            </Grid>
                            <Grid xs={3}>
                             <Box
                               display="flex"
                               sx={{
                                 flexDirection: "row",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 alignContent: "center",
                                 height: "50px",
                                 fontSize: "15px"
                 
                               }}
                             > 
                             <p style={{width: "120px", color: "black",fontWeight: "600", marginLeft:"5px"}}>
                                       Care Facility:</p>
                                      <TextField
                                       sx={{"& .MuiInputBase-input": {padding: "8.5px 14px"}, "& .MuiFormControl-root":{alignContent:"center"}}}
                                       placeholder="Care Facility"
                                       type="text"
                                       variant="outlined"
                                       margin="normal"
                                       name="careFacility"
                                       value={reqFields.careFacility}
                                       onChange={handleChange}
                               />
                             
                             </Box> 
                             </Grid>
                              <Grid xs={3}>
                             <Box
                               display="flex"
                               sx={{
                                 flexDirection: "row",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 alignContent: "center",
                                 height: "50px",
                                 fontSize: "15px"
                               }}
                             > 
                              <p style={{width: "110px", color: "black",fontWeight: "600", marginLeft:"5px"}}>
                               Updated By:</p>
                            <TextField
                               sx={{"& .MuiInputBase-input": {padding: "8.5px 14px"},"& .MuiFormControl-root":{alignContent:"center"}}}
                               placeholder="Updated By"
                               type="text"
                               variant="outlined"
                               margin="normal"
                               name="updatedBy"
                               value={reqFields.updatedBy}
                               onChange={handleChange}
                               />
                            
                            
                            </Box>
                            </Grid>
                             <Grid xs={3}>
                             <Box
                               display="flex"
                               sx={{
                                 flexDirection: "row",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 alignContent: "center",
                                 height: "50px",
                                 fontSize: "15px",
                                 columnGap: "1rem"
                               }}
                             > 
                             <Button
                               variant="contained"
                               style={{ backgroundColor:"#002d82",width: "110px", height:"35px", marginLeft: "0.5rem", marginTop:"4px"}}
                               onClick={handleSearch}
                               >
                               Search
                               </Button>
                       
                               <Button
                               variant="contained"
                               style={{ backgroundColor:"#002d82",width: "110px", height:"35px", marginTop:"4px"}}
                               onClick={handleReset}
                               >
                               Reset
                                 </Button> 
                             
                             </Box> 
                             </Grid>
                             </Box> 
                                 
                             <Box
                             component="span"
                             sx={{ 
                               position: "absolute",
                               top: "-12px",
                               left:"15px",
                               //transform:"translateX(-50%)",
                               backgroundColor: "white",
                               padding: "0 10px",
                               fontSize:"14px",
                               whiteSpace:"nowrap"
                               }}
                                 >
                                  Filter Criteria:   
                                       
                             </Box>
                             </Box>
                     </div>
                     </Grid>    
                     </div> 
          
        
        <Box sx={{display:"flex", flexDirection:"row", width:"100%", height:"55px", alignItems:"center"}}>
          <Box sx={{width:"50%", alignContent:"left", float:"left", justifyContent:"left",textAlign:"left"}}>
            <div style={{alignContent:"left", marginTop:"10px"}}>
            {aclAuditData && aclAuditData.length>0? 
                <CustomExcelExport
                filename={`AccessControlAudit.xlsx`}
                data={aclAuditData}
                headers={aclAuditExcelColumns}
                type={"align-left"}
                >
            </CustomExcelExport>
              :null}
            </div>
            </Box>
            <Box sx={{width:"50%", alignContent:"right", float:"right", justifyContent:"right"}}>
                <div style={{alignContent:"right", textAlign:"right"}}>
                {(aclAuditData && aclAuditData.length> 0) || searching ?
                <TextField
                  placeholder="Search"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  value={searchField}
                  onChange={(e)=>handleChangeInput(e)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <Search />
                        </IconButton>
                      </InputAdornment>
                    ),
                    sx: { borderRadius: "5px", height: "40px", textAlign:"center" },
                  }}
                />
              : null}
                </div>
            </Box>		 
         </Box>
            <DataTable
              title=""
              key={tableKey}
              columns={aclAuditColumns}
              data={aclAuditData}
              pagination
              striped
              highlightOnHover
              customStyles={customStyle}
              defaultSortFieldId={null}
              defaultSortAsc={null}
              paginationRowsPerPageOptions={[5, 10, 15, 20]}
              paginationResetDefaultPage={resetPagination}
              paginationPerPage={5}
              paginationComponentOptions={{
                rowsPerPageText: "Records per page",
                rangeSeparatorText: "Out of",
              }}
            />
            </Box>
          </div>
          {errormodalopen && (
            <ErrorModal open={errormodalopen} onClose={() => seterrormodalOpen(false)} />
          )}
        </div>
      );
}

export default AclAudit;
